<template>
  <footer v-if="!isWebview">
    <div class="inner">
      <div class="container">
        <MainLogo />

        <div class="item family">
          <div class="tit">
            {{ $t('familysite') }}
          </div>
          <ul>
            <li>
              <a href="https://watv.org/ko">{{ $t('하나님의교회공식사이트') }}</a>
            </li>
            <li>
              <a href="https://asez.org/ko">{{ $t('asez대학생봉사단') }}</a>
            </li>
            <li>
              <a href="https://asezwao.org/ko">{{ $t('asezwao직장인청년봉사단') }}</a>
            </li>
            <li>
              <a href="https://asezstar.org">{{ $t('asezstar학생봉사단') }}</a>
            </li>
            <li>
              <a href="https://ourmother.kr">{{ $t('우리어머니글과사진전') }}</a>
            </li>
            <li>
              <a href="https://thankfather.org">{{ $t('진심아버지를읽다') }}</a>
            </li>
          </ul>
        </div>

        <div class="item contact">
          <div class="tit">
            {{ $t('contact') }}
          </div>
          <ul>
            <li>{{ $t('경기도성남시분당구성남분당우체국사서함119호') }}</li>
            <li>{{ $t('tel0317385999fax0317385998') }}</li>
            <li>{{ $t('총회경기도성남시분당구수내로50수내동') }}</li>
            <li>{{ $t('대표교회경기도성남시분당구판교역로35백현동526') }}</li>
          </ul>
        </div>

        <div class="item sns">
          <div class="tit">
            {{ $t('followus') }}
          </div>
          <ul>
            <li class="kakaotalk" @click="onClickShareKakaoTalk">
              <a><span class="blind">카카오톡</span></a>
            </li>
            <li class="facebook">
              <a title="Facebook" rel="nofollow noopener" target="_blank" @click="shareFacebook(url)">
                <span class="blind">페이스북</span>
              </a>
            </li>
            <li class="x">
              <a href="#" title="X" rel="nofollow noopener" target="_blank" @click="shareX(url)">
                <span class="blind">X</span>
              </a>
            </li>
            <li class="sms">
              <a href="#" title="SMS" rel="nofollow noopener" @click="shareSMS(url)">
                <span class="blind">문자메시지</span>
              </a>
            </li>
            <li class="copy-url">
              <a title="copy-url" rel="nofollow noopener" @click="onClickCopyURL">
                <span class="blind">주소 복사</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="copy">
        {{ $t('worldmissionsocietychurchofgodallrightsreserved') }}
        <NuxtLink :to="$localePath('/policy')" class="link-policy">
          {{ $t('개인정보처리방침') }}
        </NuxtLink>
      </div>
    </div>
  </footer>

  <!-- for PWA -->
  <footer v-else class="pwa-only">
    <div class="container">
      <div class="item sns">
        <ul>
          <li class="kakaotalk" @click="onClickShareKakaoTalk">
            <a><span class="blind">카카오톡</span></a>
          </li>
          <li class="facebook">
            <a title="Facebook" rel="nofollow noopener" target="_blank" @click="shareFacebook(url)">
              <span class="blind">페이스북</span>
            </a>
          </li>
          <li class="x">
            <a href="#" title="X" rel="nofollow noopener" target="_blank" @click="shareX(url)">
              <span class="blind">X</span>
            </a>
          </li>
          <li class="sms">
            <a href="#" title="SMS" rel="nofollow noopener" @click="shareSMS(url)">
              <span class="blind">문자메시지</span>
            </a>
          </li>
          <li class="copy-url">
            <a title="copy-url" rel="nofollow noopener" @click="onClickCopyURL">
              <span class="blind">주소 복사</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="copy">
        {{ $t('worldmissionsocietychurchofgodallrightsreserved') }}
        <NuxtLink :to="$localePath('/policy')" class="link-policy">
          {{ $t('개인정보처리방침') }}
        </NuxtLink>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
const url = ref<string>('')
const { isWebview } = useWebviewBridge()
const { showToast } = useToast()
const { $t } = useNuxtApp()

onMounted(() => {
  url.value = window.location.href
})
const { shareKakaoTalk, shareFacebook, shareX, shareSMS, copyURL, shareImage } = useShare()

function onClickCopyURL() {
  copyURL(url.value)
  showToast({ message: $t('주소가복사되었어요') })
}

function onClickShareKakaoTalk() {
  shareKakaoTalk(
    url.value,
    $t('어머니사랑과평화의날un국제관용의날기념캠페인'),
    removeTag($t('어머니사랑을품은한사람의작은실천은세상을변화시키는시작이자인류가평화로나아가는첫걸음입니다br지금함')),
    shareImage.value,
  )
}
</script>
